export const UserActions={
    LOAD_USER_BOOT:"LOAD_USER_BOOT",
    SAVE_USER_DETAILS:"SAVE_USER_DETAILS",
    SIGN_OUT:"SIGN_OUT",
    PROJECT_SELECTED:"PROJECT_SELECTED",
    REFERENCE_UPDATED:"REFERENCE_UPDATED"
}